<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 11 11"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 5.38974L3.92331 9L10 1" :stroke="fill" stroke-linecap="round" stroke-width="2"/>
  </svg>

</template>

<script>
export default {
  name: 'Check',
  props: {
    width: {
      type: String,
      required: false,
      default: '11px'
    },
    height: {
      type: String,
      required: false,
      default: '11px'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
